import { connect } from 'react-redux';

import MarkerPreview from 'components/MarkerSettings/MarkerPreview';
import { changePanel, PANELS } from 'modules/navigation/activePanel';
import { setActiveMarker } from 'modules/navigation/activeMarker';
import { getMarkers } from 'modules/markers';
import { showModal } from 'modules/modal';
import MODAL from 'components/Shared/Modals';
import { changePreviewLocation, getPreviewLocationZoom } from 'modules/navigation/preview';
import { getStyle } from 'modules/style';

const mapStateToProps = (state) => ({
    markers: getMarkers(state),
    styleImageUrl: getStyle(state).imageUrl || '/Images/img-style-preview-default.png',
    zoom: getPreviewLocationZoom(state),
});

const mapDispatchToProps = (dispatch) => ({
    onHighlightClick: (marker, zoom) => {
        dispatch(changePreviewLocation({ center: marker.location, zoom }));
    },
    onAddClick: () => {
        dispatch(changePanel(PANELS.MARKER));
    },
    onDeleteClick: (marker) => {
        dispatch(showModal(MODAL.CONFIRM_MARKER_DELETE, { id: marker.id }));
    },
    onEditClick: (marker, zoom) => {
        dispatch(setActiveMarker(marker.id));
        dispatch(changePreviewLocation({ center: marker.location, zoom }));
        dispatch(changePanel(PANELS.MARKER));
    },
    onInfoWindowClick: (marker, zoom) => {
        dispatch(setActiveMarker(marker.id));
        dispatch(changePreviewLocation({ center: marker.location, zoom }));
        dispatch(changePanel(PANELS.INFO_WINDOW));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(MarkerPreview);
